const TablePosition = require('../TablePosition')

/**
 * Remove current row in a table. Clear it if last remaining row
 *
 * @param {Object} opts
 * @param {Slate.Transform} transform
 * @param {Number} at
 * @return {Slate.Transform}
 */
function removeRow (opts, transform, at) {
  const { state } = transform
  const { startBlock } = state

  const pos = TablePosition.create(state, startBlock, opts)
  const { table } = pos

  if (typeof at === 'undefined') {
    at = pos.getRowIndex()
  }

  const row = table.nodes.get(at)
    // Update table by removing the row
  if (pos.getHeight() > 1) {
    let prevRowAt = (at - 1 > -1) ? at - 1 : 0
    transform
      .collapseToEndOf(
          table.nodes
            .get(prevRowAt)
            .nodes.get(0)
      )
      .focus()
      .removeNodeByKey(row.key)
  } else {
    transform.removeNodeByKey(table.key)
  }

  return transform
}

module.exports = removeRow



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/deep-table-plugin/transforms/removeRow.js